import { __rest } from 'tslib';
import React from 'react';
import { ToggleButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekToggleButton = styled((_a) => {
    var props = __rest(_a, ["variant"]);
    return React.createElement(ToggleButton, Object.assign({}, props));
})(({ theme, variant }) => ({
    "&.MuiToggleButton-root": Object.assign(Object.assign(Object.assign({ color: theme.palette.primary.main, textTransform: "capitalize", border: `${theme.spacing(0.1)} solid transparent`, boxShadow: `0px ${theme.spacing(0.2)} ${theme.spacing(0.5)} ${theme.palette.grey[100]}, 0px 0px ${theme.spacing(0.1)} ${theme.palette.grey[100]}` }, theme.typography.h4), { "&.Mui-selected": {
            color: theme.palette.text.secondary,
            "&.MuiToggleButton-secondary": {
                backgroundColor: theme.palette.secondary.main,
            },
            "&.MuiToggleButton-primary": {
                backgroundColor: theme.palette.primary.main,
            },
        }, "&.Mui-disabled": {
            color: theme.palette.text.disabled,
            backgroundColor: theme.palette.grey[50],
        } }), (variant === "outlined" && {
        "&.Mui-selected": {
            fontWeight: theme.typography.fontWeightBold,
            "&.MuiToggleButton-primary": {
                color: theme.palette.primary.main,
                border: `${theme.spacing(0.1)} solid ${theme.palette.primary.main}`,
                backgroundColor: theme.palette.primary.contrastText,
            },
            "&.MuiToggleButton-secondary": {
                color: theme.palette.secondary.main,
                border: `${theme.spacing(0.1)} solid ${theme.palette.secondary.main}`,
                backgroundColor: theme.palette.secondary.contrastText,
            },
        },
    })),
}));

export { PeekToggleButton, PeekToggleButton as default };
